import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const CertificateQRCode = ({ certificateId }) => {
  const verifyUrl = `https://www.clientcodeai.in/verify/${certificateId || 'CCAI-1234-5678'}`;

  return (
    <div className="flex flex-col items-center bg-[#ffffff] p-2 rounded-lg border border-[#E5E7EB] shadow-sm">
      <QRCodeSVG 
        value={verifyUrl}
        size={64}
        bgColor="#ffffff"
        fgColor="#1A2340"
        level="Q"
      />
      <div className="bg-[#2D8CFF] w-full mt-2 rounded flex items-center justify-center py-1">
        <span className="text-[8px] text-[#ffffff] font-inter uppercase tracking-[0.1em] font-bold">VERIFY STATUS</span>
      </div>
    </div>
  );
};

export default CertificateQRCode;
